//CHEST IS DONE
let Chest= {
    None:{
        Name: "None",
        Stats:[0,0,0,0,0]
    },
    Muscle:{
        Name: "Muscle",
        Stats:[2,0,-2,0,0]
    },
    Turbo:{
        Name: "Turbo",
        Stats:[0,2,0,-2,0]
    },
    Cannon:{
        Name: "Cannon",
        Stats:[-2,0,2,0,0]
    },
    Chain:{
        Name: "Chain",
        Stats:[0,0,0,2,-2]
    },
    Trick:{
        Name: "Trick",
        Stats:[-2,0,0,0,2]
    },
    Bushido:{
        Name: "Bushido",
        Stats:[4,-1,-1,-1,-1]
    },
    Knight:{
        Name: "Knight",
        Stats:[+2,-2,+1,-2,+1]
    },
    Shellfish:{
        Name: "Shellfish",
        Stats:[-2,+2,+1,-2,+1]
    }
};

export default Chest